export default ({ instance }) => {
	return {
		buscarAcessos() {
			return instance({
				method: "get",
				url: "acessos/buscar",
			});
		},
		adicionarAcessos(acesso) {
			return instance({
				method: "post",
				url: "acessos/adicionar",
				data: acesso,
			});
		},
		editarAcessos(acesso) {
			return instance({
				method: "post",
				url: "acessos/atualizar",
				data: acesso,
			});
		},
		excluirAcessos(acesso) {
			return instance({
				method: "post",
				url: "acessos/remover",
				data: acesso,
			});
		},
		listarHistorico() {
			return instance({
				method: "get",
				url: "acessos/buscarhistorico",
			});
		},
	};
};
